var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded ml-1",attrs:{"color":"primary","small":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-pencil-plus")]),_vm._v("Thêm")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }